import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CallToAction } from './call-to-action-button';
import { SvodSource } from '../../../queries/ats/titles/types/sources';
import { SvgCart } from '../../../icons';
import { routes } from '../../../routes/route-utils';
import { Asset } from '../../../queries/ats/titles/types/asset';
import i18n from '../../../i18n';
import { FocusedAsset } from '../use-focused-asset';

interface SvodGuestUserProps {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: SvodSource;
}

export function SvodGuestUser({ asset, focusedAsset, source }: SvodGuestUserProps) {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <CallToAction
      text={{
        primary: t('details:get-access'),
        secondary: asset.type === 'series' ? getSeriesAssetText(focusedAsset) : undefined,
      }}
      image={{
        src: source.image,
        alt: source.name,
      }}
      icon={<SvgCart />}
      to={routes.login(location)}
    />
  );
}

function getSeriesAssetText(asset: FocusedAsset) {
  if (!asset.series?.seasonCount) {
    return undefined;
  }

  const seasonsPluralKey = asset.series.seasonCount > 1 ? 'other' : 'one';

  return i18n.t(`common:seasons_${seasonsPluralKey}`, { count: asset.series.seasonCount });
}
